import { Model } from "./model";

export class Language extends Model {
	private name: string = "";
	private iso_alpha_2: string = "";
	private enabled: boolean = true;

	public isEnabled(): boolean {
		return this.enabled;
	}

	public getIsoCode(): string {
		return this.iso_alpha_2;
	}

	public getName(): string {
		return this.name;
	}
}
